// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__i-Ylb","wrapper":"Footer_wrapper__D25I2","copyright":"Footer_copyright__hQhVM"};